import { productionEnv } from 'constants/debug';

const azureApiScope = productionEnv
  ? window.env.AZURE_API_SCOPE
  : import.meta.env.VITE_AZURE_API_SCOPE;

// Entra ID
const envAuthority = productionEnv
  ? window.env.AZURE_AUTHORITY
  : import.meta.env.VITE_AZURE_AUTHORITY;
export const msalConfig = {
  auth: {
    authority:
      !!envAuthority && envAuthority !== ''
        ? envAuthority
        : 'https://login.microsoftonline.com/common',
    clientId: productionEnv
      ? window.env.AZURE_CLIENT_ID
      : import.meta.env.VITE_AZURE_CLIENT_ID,
    audience: productionEnv
      ? window.env.AZURE_API_AUDIENCE
      : import.meta.env.VITE_AZURE_API_AUDIENCE,
    redirectUri: window.location.origin,
    knownAuthorities: [
      productionEnv
        ? window.env.KNOWN_AUTHORITIES
        : import.meta.env.VITE_KNOWN_AUTHORITIES,
    ],
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    allowRedirectInIframe: true,
  },
};

export const loginRequest = {
  scopes: [azureApiScope, 'user.read'],
};

export const tokenRequest = {
  scopes: [azureApiScope, 'user.read'],
};

// /Entra ID
